import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const Box = () => (
  <React.Fragment>
    <div className="box" />
    <div className="box description" />
    <div className="box description description-shorter" />
  </React.Fragment>
);

export const Boxes3 = () => (
  <div className="row">
    <div className="col-4">
      <Box />
    </div>
    <div className="col-4">
      <Box />
    </div>
    <div className="col-4">
      <Box />
    </div>
  </div>
);

export const Boxes2 = () => (
  <div className="row">
    <div className="col-6">
      <Box />
    </div>
    <div className="col-6">
      <Box />
    </div>
  </div>
);

export const ErrorEmptyChannel = ({ channelName = '', errorMsg = 'channel_no_videos' }) => {
  const { t } = useTranslation();
  return (
    <div className="ct-error-empty-channel" data-e2e="ct-empty-channel">
      <h1>{channelName}</h1>
      <p>{t(errorMsg)}</p>
      <div className="ct-error-empty-channel__boxes3">
        <Boxes3 />
      </div>
      <div className="ct-error-empty-channel__boxes2">
        <Boxes2 />
      </div>
      <div className="ct-error-empty-channel__boxes1">
        <Box />
      </div>
    </div>
  );
};

ErrorEmptyChannel.propTypes = {
  channelName: PropTypes.string,
  errorMsg: PropTypes.string,
};
